// Entry point for the build script in your package.json
import Rails from "@rails/ujs";
import "./autoform.js";
import "./collapse.js";
import "./dirty.js";
import "./helpers.js";
import "./generate_public.js";
import "./pages.js";
import "./preview.js";
import "./search_entries.js";
import "./tinymce-extras.js"
